import * as Components from "./components";
import '../node_modules/modern-normalize/modern-normalize.css';
import './styles/index.scss';

const main = () => {
  if (typeof document === `undefined` || typeof window === `undefined`) {
    return;
  }

  document.addEventListener(`DOMContentLoaded`, () => {
    document.querySelectorAll(`[data-component]`).forEach((element) => {
      const componentId = element.getAttribute(`data-component`);

      if (typeof Components?.[componentId] === `function`) {
        Components[componentId](element);
      }
    });

    if (
      window.location.pathname.startsWith('/maze') ||
      window.location.pathname.startsWith('/resources') ||
      window.location.pathname.startsWith('/nevis')
    ) {
      document.body.style.background = '#000000';

      // AOS hackery
      const mainContent = document.getElementById('main-content');
      const mainHeader = document.getElementById('main-header');

      if (mainContent) {
        mainContent.style.opacity = 1;
      }

      if (mainHeader) {
        mainHeader.style.opacity = 1;
      }
    }
  });
};

main();
